import $ from 'jquery';
import 'bootstrap';
import 'popper.js';
import { initGrowthChart } from './components/growth_chart';
import { initSectorChart } from './components/sector_chart';
window.$ = $;

$(function () {
    //console.log( "Hello FilePoint!" );

    'use strict'; // Start of use strict
    $('[data-toggle="tooltip"]').tooltip(); //enable tooltips

    watchNavbar();
    initGrowthChart();
    initSectorChart();
});



function watchNavbar() {
    $(window).on('scroll', function () {
        var position = $(this).scrollTop();
        if (position > 50) {
            $('#mainNav').addClass('scroll');
        } else {
            $('#mainNav').removeClass('scroll');
        }
    });

    $('.mobile-menu-btn').on('click', function () {
        $('.navbar-links').addClass('show');
        $(".main-nav-overlay").addClass('show');
    });

    $('.mobile-close-btn').on('click', function () {
        $('.navbar-links').removeClass('show');
        $(".main-nav-overlay").removeClass('show');
    });

    $('.nav-link').on('click', function () {
        $('.navbar-links').removeClass('show');
        $(".main-nav-overlay").removeClass('show');
    });
}
